import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit
} from '@angular/core';
import { answerConst } from '../../constants';
import { FaqService } from './faq.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, AfterViewInit, OnDestroy {
  formValues = answerConst;
  faqQuestionAnswerList = answerConst.faqList;
  isPageLoader: boolean = false;
  faqList: Array<{
    faqId: number | null;
    question: string;
    answer: string;
    isLoader: boolean;
    isOpen?: boolean;
  }> = [];

  private observer?: IntersectionObserver;

  constructor(
    private faqService: FaqService,
    private hostElement: ElementRef<HTMLElement>
  ) {}

  ngOnInit(): void {
    this.getAllFaq();
  }

  ngAfterViewInit(): void {
    this.initScrollReveal();
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  getAllFaq() {
    this.isPageLoader = true;
    this.faqList = [];

    this.faqService.getFaqList().then((faqRes) => {
      if (faqRes && faqRes['nodes'] && Array.isArray(faqRes['nodes']) && faqRes['nodes'].length > 0) {
        this.setDataFormat(faqRes['nodes']);
        console.log("response : ", faqRes['nodes']);
      } else {
        // Fallback to static pre-configured FAQs
        this.setDataFormat(this.faqQuestionAnswerList);
      }
    }).catch((err) => {
      console.warn('Could not fetch dynamic FAQs, falling back to static FAQs:', err);
      // Fallback to static pre-configured FAQs on error
      this.setDataFormat(this.faqQuestionAnswerList);
    });
  }

  setDataFormat(response: any[]) {
    this.faqList = (response || []).map(event => ({
      faqId: event.faqId || null,
      question: event.question || event.faqQuestion || "",
      answer: event.answer || event.faqAnswer || "",
      isLoader: false,
      isOpen: false 
    }));
    this.isPageLoader = false;

    setTimeout(() => {
      this.initScrollReveal();
    }, 50);
  }

  toggleAccordion(index: number) {
    this.faqList.forEach((faq, i) => {
      if (i !== index) faq.isOpen = false; 
    });

    this.faqList[index].isOpen = !this.faqList[index].isOpen;
  }

  private initScrollReveal(): void {
    if (this.observer) {
      this.observer.disconnect();
    }

    const host = this.hostElement?.nativeElement;
    if (!host) {
      return;
    }

    const elements = Array.from(
      host.querySelectorAll<HTMLElement>('[data-reveal]')
    );

    if (!elements.length) {
      return;
    }

    if (
      typeof window === 'undefined' ||
      typeof IntersectionObserver === 'undefined'
    ) {
      elements.forEach((el) => {
        el.classList.add('reveal-visible');
      });
      return;
    }

    elements.forEach((element) => {
      element.classList.remove('reveal-visible');
      element.classList.add('reveal-hidden');

      const delay = element.getAttribute('data-reveal-delay');
      if (delay) {
        const delayNumber = parseInt(delay, 10);
        if (!Number.isNaN(delayNumber)) {
          element.style.setProperty(
            '--reveal-delay',
            `${delayNumber}ms`
          );
        }
      }
    });

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          const element = entry.target as HTMLElement;
          element.classList.remove('reveal-hidden');
          element.classList.add('reveal-visible');

          this.observer?.unobserve(element);
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      }
    );

    elements.forEach((element) => {
      this.observer?.observe(element);
    });
  }
}
